import {
  Currency,
  GoogleSchema,
  useMobile,
  usePricing,
} from "@with-nx/hooks-n-helpers";
import { useServerRegion } from "@with-nx/region";
import { DesignedButton, LoadingShimmer } from "@with-nx/simple-ui/atoms";
import { VisibleContainer } from "@with-nx/simple-ui/molecules";
import { ReusablePricingBox } from "@with-nx/simple-ui/organisms";
import { useRouter } from "next/router";
import { Box } from "simple-effing-primitive-layout";

const ChoreoPricingCardElement = () => {
  const mobile = useMobile();
  const region = useServerRegion();
  const pricing = usePricing({
    type: "CHOREO_GUIDE",
    variation: "REGULAR",
    region: region?.id,
  });

  const router = useRouter();

  if (!pricing || region?.meta?.loading) {
    return <LoadingShimmer parse="h:440 w:100%" />;
  }

  return (
    <ReusablePricingBox
      description="Enhance your choreography skills with the one-year license"
      label="1-year license"
      price={Currency.format(
        Number(pricing?.price || "0"),
        region?.currency?.code || "USD"
      )}
      features={[
        "Multi-User Access",
        "Performance Rights",
        "Choreography License",
        "3-4 Hours of Instructions",
      ]}
      onLearnMore={undefined}
      minimal={true}
      span={mobile ? 24 : 12}
      mode="top-left-blue"
    >
      <Box css="d:flex a:center j:center" parse="pt:36">
        <DesignedButton
          label="Request Information"
          theme="white"
          size="large"
          href={`/contact/start?mode=learn-more&referrer=${router.asPath}`}
        />
      </Box>
    </ReusablePricingBox>
  );
};

export const ChoreoPricingCard = () => {
  return (
    <VisibleContainer>
      <ChoreoPricingCardElement />
    </VisibleContainer>
  );
};
